import { z } from 'zod'

import { filtersSchema } from '@/shared/components/filter/validation'
import { SavedFilterType } from '@/shared/generated'

export const updateReportSchema = z.object({
	name: z.string(),
	type: z.enum([SavedFilterType.Products, SavedFilterType.Anchors]),
	is_public: z.boolean().default(false),
	filters: filtersSchema,
})
export const createReportSchema = z.object({
	name: z.string(),
	type: z.enum([SavedFilterType.Products, SavedFilterType.Anchors]),
	is_public: z.boolean().default(false),
	filters: filtersSchema,
})
